module.exports = __webpack_public_path__ + "media/open.d640690b.mp3";